import { QUERY_PERSIST_KEY } from "@/services/query";

export const CURRENT_USER_PROFILE_QUERY_KEY = [
  "users",
  "current",
  "profile",
  QUERY_PERSIST_KEY,
];

export const UPDATE_CONTEXT_MUTATION_KEY = [
  "users",
  "current",
  "update",
  "context",
];
